<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'FourOhFour',

    metaInfo() {
      return {
        title: this.$t('notFound.metaTitle'),
        meta: [
          { vmid: 'robots', name: 'robots', content: 'noindex, nofollow' },
          { vmid: 'render-status', name: 'render:status_code', content: '404' },
        ],
      }
    },

    extends: View,

    mixins: [
      LoadSections([
        '404',
        'keep-in-touch2', // 联系我们
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'about',
      },
    },

    mounted() {
      this.ensureRenderStatusCodeMeta()
    },

    beforeDestroy() {
      const meta = document.head.querySelector('meta[name="render:status_code"]')
      if (meta?.dataset?.managedBy === 'yooxplore-404') {
        meta.remove()
      }
    },

    methods: {
      ensureRenderStatusCodeMeta() {
        if (typeof document === 'undefined') return
        let meta = document.head.querySelector('meta[name="render:status_code"]')
        if (!meta) {
          meta = document.createElement('meta')
          meta.setAttribute('name', 'render:status_code')
          document.head.appendChild(meta)
        }
        meta.setAttribute('content', '404')
        meta.dataset.managedBy = 'yooxplore-404'
      },
    },
  }
</script>
